<div class="p-3">
  <div class="mb-3">
    <h3 class="mt-0 mb-1 title">{{ 'scwSolution.title' | translate }}</h3>
    <p class="m-0 description">{{ 'scwSolution.description' | translate }}</p>
    <mat-progress-bar *ngIf="store.isLoading$()" mode="indeterminate"></mat-progress-bar>
  </div>
  <div class="app-list">
    @for (item of list$(); track item.name) {
      <button
        mat-button
        class="app-item"
        [class.is-current-tool]="item.isCurrentTool"
        [class.disabled]="item.disabled"
        [matMenuTriggerFor]="item.isCurrentTool ? null : appMenu"
        [matMenuTriggerData]="{ selectedItem: item }"
        (click)="$event.stopPropagation()"
      >
        <div class="app-item-content">
          <div class="indicator-wrapper">
            <div *ngIf="item.isCurrentTool" class="indicator-dot"></div>
          </div>

          <img class="app-icon" [src]="logoFilePath + item.moduleName + '.png'" alt="{{ item.name }} Logo" />
          <span class="name">{{ item.name }}</span>

          <div class="spacer"></div>

          @if (!item.disabled) {
            <mat-icon class="hover-arrow">arrow_forward</mat-icon>
          }
        </div>
      </button>
    }
  </div>
</div>

<mat-menu #appMenu="matMenu">
  <ng-template matMenuContent let-selectedItem="selectedItem">
    <button *ngIf="!selectedItem.disabled" mat-menu-item (click)="openUrl(selectedItem.link, '_blank')">
      <mat-icon>open_in_new</mat-icon>
      <span>{{ 'scwSolution.button.newPage' | translate }}</span>
    </button>
    <button *ngIf="!selectedItem.disabled" mat-menu-item (click)="openUrl(selectedItem.link, '_self')">
      <mat-icon>open_in_browser</mat-icon>
      <span>{{ 'scwSolution.button.currentPage' | translate }}</span>
    </button>

    <button *ngIf="selectedItem.disabled" mat-menu-item (click)="openUrl(bookDemoUrl, '_blank')">
      <mat-icon>open_in_new</mat-icon>
      <span>{{ 'general.bookDemo' | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
